/**
 * React component that renders hashtag button that shows remaining tags on mouseover
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Yucho Ho
 */
import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import nanoid from 'nanoid'
import { Button, UncontrolledTooltip } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import TagList from 'client/shared/js/components/TagList'
import styles from './HashtagButton.module.scss'

const HashtagButton = ({ className, btnClassName, tagOrder, index, color, size, placement, onClick }) => {
  const id = useMemo(() => `hashtag-btn-${nanoid()}`, [])
  const tagOrderSlice = useMemo(() => tagOrder.slice(index), [tagOrder, index])

  return (
    <div className={cx(styles['tag'], 'tag d-flex align-items-center', className)}>
      <Button
        id={id}
        className={cx('round', btnClassName)}
        color={color}
        size={size}
        onClick={onClick}>
        <FontAwesomeIcon icon={['fas', 'hashtag']} className='font-inherit' />
      </Button>
      <UncontrolledTooltip className={styles['hashtag-tooltip']} target={id} placement={placement}>
        <TagList tagOrder={tagOrderSlice} color='naked' size='xs' />
      </UncontrolledTooltip>
    </div>
  )
}

HashtagButton.propTypes = {
  className: PropTypes.string,
  btnClassName: PropTypes.string,
  tagOrder: PropTypes.array,
  index: PropTypes.number,
  color: PropTypes.string,
  size: PropTypes.string,
  placement: PropTypes.string,
  onClick: PropTypes.func
}

HashtagButton.defaultProps = {
  tagOrder: [],
  index: 0,
  color: 'tag-pro',
  size: 'sm',
  onClick: () => false
}

export default HashtagButton
